// api/houtai/index.js
import request from '@/utils/request';

// 获取阿里云图片列表
export const userpiclist = (params) => {
    return request.get('/houtai/userPic', { params });  // 传递 params 包含日期
  }

  // 获取阿里云图片列表
export const deleteuserpi = (fileUrl) => {
  return request.post('/houtai/delete/userpic', fileUrl );  // 传递 params 包含日期
}
export const userdeshesPic = (params) => {
  return request.get('/houtai/userdeshesPic', { params });  // 传递 params 包含日期
}





// 获取用户数据统计（注销前展示）
export const getUserDataStats = (data) => {
  return request.post('/houtai/getUserDataStats', data);
};

// 用户注销 - 删除所有关联数据
export const deleteUserAccount = (data) => {
  return request.post('/houtai/deleteUser', data);
};


// ============ 操作日志API ============

// 获取操作日志列表
export const getOperationLogs = (params) => {
    return request.get('/houtai/getOperationLogs', { params });
};

// 获取操作日志统计
export const getOperationLogsStats = () => {
    return request.get('/houtai/getOperationLogsStats');
};

// 清空操作日志
export const clearOperationLogs = (data) => {
    return request.post('/houtai/clearOperationLogs', data);
};



// 获取串门厨房成员列表
export const getKitchenMembers = (params) => {
    return request.get('/houtai/getKitchenMembers', { params })
}

// 添加厨房成员
export const addKitchenMember = (data) => {
    return request.post('/houtai/addKitchenMember', data)
}

// 移除厨房成员
export const removeKitchenMember = (data) => {
    return request.post('/houtai/removeKitchenMember', data)
}

// 设置管理员
export const setKitchenAdmin = (data) => {
    return request.post('/houtai/setKitchenAdmin', data)
}


// ========== 新的OSS操作API ==========

// 上传文件到OSS
// export const uploadToOSS = (file, customPath = '') => {
//   const formData = new FormData();
//   formData.append('file', file);
//   if (customPath) {
//     formData.append('path', customPath);
//   }
//   return request.post('/api/oss/upload', formData, {
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     }
//   });
// };

// 获取OSS文件列表
// export const getOSSFileList = (prefix = '', maxKeys = 100) => {
//   return request.get('/api/oss/files', {
//     params: { prefix, maxKeys }
//   });
// };

// 删除OSS文件
// export const deleteOSSFile = (fileName) => {
//   return request.delete(`/api/oss/files/${encodeURIComponent(fileName)}`);
// };

// 批量删除OSS文件
// export const batchDeleteOSSFiles = (fileNames) => {
//   return request.delete('/api/oss/files', {
//     data: { fileNames }
//   });
// };















